import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  @Input()
  public clickHandler(): void {}

  @Input()
  color: string = '';

  @Input()
  disabled: boolean = false;

  @Input()
  label: string = '';

  @Input()
  type: 'submit' | 'reset' | 'button' = 'button';

  @Output()
  public clickEmitter: EventEmitter<void> = new EventEmitter();

  public onClick(): void {
    this.clickEmitter.emit();
    this.clickHandler();
  }

  public getColorClass(): string {
    switch (this.color) {
      case 'primary':
        return 'btn-primary';
      case 'secondary':
        return 'btn-secondary';
      default:
        return 'btn-primary';
    }
  }
}
